import { Brand, CreativeSystem, MarketIntelligence, CompetitiveIntel, AudienceIntelligence, SocialAndDigital } from "@/schema/brand-intelligence";

const brand: Brand = {
  name: "Wakefit Innovations Limited",
  industry: ["Home Furnishings"],
  sub_industry: ["D2C home and furnishings company offering mattresses, furniture, and furnishing"],
  founded_year: 2016,
  founded_original_name: "Wakefit Innovations Private Limited",
  headquarters: ["Bengaluru, Karnataka, India"],
  tagline_primary: "Democratizing sleep for one and all",
  mission: "To democratize sleep for one and all with premium quality sleep products at affordable pricing.",
  vision: "To be the most loved home solutions company in India.",
  overview:
    "Wakefit Innovations Limited is a D2C home and furnishings company established in 2016, offering mattresses, furniture, and furnishings through omnichannel presence. It is India's largest D2C home and furnishings company by revenue.",
  scale: {
    revenue: 1273.69,
    employees_estimate: 2212,
    markets_served_count: 2,
    operating_countries_count: 2,
  },
  global_presence: {
    regions: [
      {
        region: "India",
        headquarters: "Bengaluru, India",
        active_markets: ["India"],
        market_type: "Direct-to-Consumer (D2C), Owned retail stores, Online marketplaces",
      },
      {
        region: "Middle East",
        headquarters: "Not found",
        active_markets: ["United Arab Emirates"],
        market_type: "Online/E-commerce focused on mattresses and mattress protectors",
      },
    ],
    key_markets_by_revenue_share: [
      {
        region: "India",
        share_percent: 98.5,
        notes: "Annual revenue of Wakefit is ₹1,310 Cr as on Mar 31, 2025, representing approximately 98-99% of total revenue (estimated based on UAE being in early pilot stage)",
      },
      {
        region: "United Arab Emirates",
        share_percent: 1.5,
        notes: "Less than 1-2% (estimated) - The pilot batch was sold out within the first few days of the launch in 2023, and the company is in early stages of international expansion",
      },
    ],
  },
};

const creativeSystem: CreativeSystem = {
  visual_identity: {
    colors: {
      primary: [
        {
          name: "Wakefit Dawn (Warm Peach/Orange)",
          hex: "#F87614",
        },
        {
          name: "Wakefit Dusk (Deep Purple)",
          hex: "#684C9A",
        },
        {
          name: "Ocean Boat Blue",
          hex: "#0075C2",
        },
      ],
      secondary: [
        {
          name: "Soft Dawn Tones",
          hex: "#FAD7B5",
        },
        {
          name: "Twilight Purples",
          hex: "#B39CD0",
        },
      ],
      accent: [
        {
          name: "Neutral Base",
          hex: "#FFFFFF",
        },
        {
          name: "Grounding Tones",
          hex: "#4A4A4A",
        },
      ],
    },
    typography: [
      {
        font_family: "Custom Design Type",
        weight: "Bold",
        usage: "Logo wordmark only",
      },
      {
        font_family: "Space Grotesk",
        weight: "Regular",
        usage: "Headlines, body text, website content",
      },
      {
        font_family: "Space Grotesk",
        weight: "Medium",
        usage: "Headlines, body text, website content",
      },
      {
        font_family: "Space Grotesk",
        weight: "Bold",
        usage: "Headlines, body text, website content",
      },
    ],
    logos: [
      {
        variant: "Primary",
        url: "https://assets.zocket.com/uploads/d3a6e977-b554-4f73-b7f7-e9333372e276-download.svg",
      },
    ],
  },
  verbal_identity: {
    voice_traits: ["Quirky", "Caring", "Innovative", "Relatable", "Educational", "Humorous", "Bold"],
    taglines: [
      "Democratizing sleep for one and all",
      "#KnowMoreSleepBetter",
      "Lafda tab hota, jab tum barabar nai sota",
      "#ApprovedByKumbhkaran",
      "#WakefitTrikea",
      "A research driven, innovative sleep solutions company.",
    ],
    messaging_dos: ["Use accessible language", "Empower customers with accurate information", "Add a dash of quirkiness to everyday messaging"],
    messaging_donts: ["Avoid political references", "Avoid religious content", "Avoid personal attacks or offensive content"],
    banned_words: ["Political references", "Religious content", "Personal attacks", "Overly technical jargon without explanation"],
  },
  creative_assets: [
    "https://assets.zocket.com/uploads/e5f638e5-9a83-4fff-aa64-3d5bbade1eb8-imgi_13_554108529_4074572479460430_3297864946431690553_n.jpg",
    "https://assets.zocket.com/uploads/e5c1f695-5809-459e-a7a2-c9aa5e99bb60-imgi_20_634079937_1426597608933195_8271718637448994112_n_1_.jpg",
    "https://assets.zocket.com/uploads/17a63fd9-3a4f-4dd7-b1c5-0584e8ee4c18-imgi_85_633033352_802921516174031_5566970190425961362_n.jpg",
    "https://assets.zocket.com/uploads/88ad0353-6395-4447-a460-70f48fe1457e-imgi_164_597762146_631191226688310_7646632847841348251_n.jpg",
    "https://assets.zocket.com/uploads/86a39654-036b-408e-9ce8-d81bedf8b1ed-imgi_170_638424207_4467691540216923_8736430714392164999_n.jpg",
    "https://assets.zocket.com/uploads/0a880125-b775-4b83-8b5d-8caf0a3524e2-imgi_184_604572368_1384446276762886_4911237244008423571_n.jpg",
  ],
  compliance: {
    brand_safety_guidelines: [],
    copyright_trademark_usage: [],
  },
  brand_architecture: {
    available_brands: ["Wakefit"],
    selected_brand: "Wakefit",
  },
  ai_creative_memory: {
    design_memory: {
      pattern_accuracy: "High",
      patterns_learned: 100,
      avg_generation: "High",
    },
    style_drift_alerts: [
      {
        title: "Style Drift Alert",
        description: "The brand's style has drifted from its original design.",
        severity: "High",
      },
      {
        title: "Font Drift Alert",
        description: "The font size has changed from the original design.",
        severity: "Medium",
      },
      {
        title: "Color Scheme Drift Alert",
        description: "The color scheme has changed from the original design.",
        severity: "Low",
      },
    ],
    preference_learning: [
      {
        preference: "Mattresses",
        score: 90,
        change: 10,
      },
      {
        preference: "Furniture",
        score: 90,
        change: 10,
      },
      {
        preference: "Finishing",
        score: 90,
        change: 10,
      },
    ],
  },
};

const marketIntelligence: MarketIntelligence = {
  kpis: {
    sentiment: 2.1,
    sentiment_graph: [
      {
        metric: "Customer Sentiment Score",
        value: "2.1/10",
        delta: "-1.2",
      },
      {
        metric: "Market Share (D2C Home & Furnishings)",
        value: "#1 Position",
        delta: "+24%",
      },
      {
        metric: "Revenue Growth",
        value: "₹1,273.69 Cr",
        delta: "+24%",
      },
      {
        metric: "EBITDA Margin",
        value: "7.87%",
        delta: "+2.5%",
      },
      {
        metric: "Store Expansion",
        value: "130+ stores",
        delta: "+33 stores",
      },
      {
        metric: "Market Position",
        value: "Top 5 Player",
        delta: "Stable",
      },
      {
        metric: "Share of Voice (Estimated)",
        value: "~8-12%",
        delta: "+2%",
      },
    ],
  },
  sentiment_summary: {
    time_range: ["2024", "2025"],
    themes: {
      positive: ["Product Quality & Comfort", "Affordability & Value Proposition", "Storage Solutions", "Installation Service (When Delivered)", "Product Innovation", "Repeat Purchase Intent"],
      neutral: ["Product Variability", "Warranty Complexity", "Price Positioning", "Brand Expansion Concerns"],
      negative: [
        "Poor Customer Service & Support",
        "Delivery Delays & Logistics Issues",
        "Return & Replacement Problems",
        "Product Quality Issues",
        "Communication Failures",
        "Installation & Assembly Problems",
        "After-Sales Service Deterioration",
      ],
    },
  },
  distribution: [
    {
      brand: "Sheela Foam (Sleepwell + Kurlon)",
      share: 51,
    },
    {
      brand: "Duroflex",
      share: 13.5,
    },
    {
      brand: "Wakefit",
      share: 9,
    },
    {
      brand: "Peps Industries",
      share: 6,
    },
    {
      brand: "Others",
      share: 20.5,
    },
  ],
  sentiment_by_product: [
    {
      product: "Orthopedic Mattresses",
      sentiment: 6.5,
      change_delta: -5,
    },
    {
      product: "Bed Frames with Storage",
      sentiment: 5.8,
      change_delta: -8,
    },
    {
      product: "Office Chairs (Gravita, Virgo)",
      sentiment: 4.2,
      change_delta: -12,
    },
    {
      product: "Sofas & Couches",
      sentiment: 3.8,
      change_delta: -15,
    },
    {
      product: "Study Tables & Furniture",
      sentiment: 4.5,
      change_delta: -10,
    },
    {
      product: "Pillows & Accessories",
      sentiment: 6.2,
      change_delta: -3,
    },
    {
      product: "Mattress Protectors",
      sentiment: 6.8,
      change_delta: 0,
    },
  ],
  top_topics: {
    praise: [
      {
        topic: "Value for Money",
        weight: 10,
      },
      {
        topic: "Product Comfort & Quality",
        weight: 9,
      },
      {
        topic: "Easy Assembly",
        weight: 8,
      },
      {
        topic: "Storage Features",
        weight: 7,
      },
      {
        topic: "Product Innovation",
        weight: 6,
      },
      {
        topic: "D2C Model Benefits",
        weight: 5,
      },
      {
        topic: "Repeat Purchase Satisfaction",
        weight: 4,
      },
    ],
    complaints: [
      {
        topic: "Poor Customer Service",
        weight: 10,
      },
      {
        topic: "Delivery Delays & Logistics Failures",
        weight: 9,
      },
      {
        topic: "Return & Replacement Issues",
        weight: 8,
      },
      {
        topic: "Product Quality & Damage",
        weight: 7,
      },
      {
        topic: "Communication & Accountability",
        weight: 6,
      },
      {
        topic: "Installation Problems",
        weight: 5,
      },
      {
        topic: "Warranty & Policy Issues",
        weight: 4,
      },
    ],
  },
};

const competitiveIntel: CompetitiveIntel = {
  primary_competitors: [
    {
      name: "SleepyCat",
      threat_level: "high",
      market_share: 9,
      sentiment: 74,
    },
    {
      name: "The Sleep Company",
      threat_level: "high",
      market_share: 6,
      sentiment: 70,
    },
    {
      name: "Duroflex",
      threat_level: "high",
      market_share: 20,
      sentiment: 68,
    },
    {
      name: "Pepperfry",
      threat_level: "high",
      market_share: 13,
      sentiment: 55,
    },
    {
      name: "Urban Ladder",
      threat_level: "medium",
      market_share: 6,
      sentiment: 60,
    },
    {
      name: "Sleepyhead",
      threat_level: "medium",
      market_share: 4,
      sentiment: 63,
    },
    {
      name: "Sheela Foam (Sleepwell)",
      threat_level: "high",
      market_share: 28,
      sentiment: 72,
    },
    {
      name: "IKEA India",
      threat_level: "medium-high",
      market_share: 4,
      sentiment: 75,
    },
  ],
  secondary_competitors: [
    {
      name: "Godrej Interio",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
    {
      name: "Nilkamal Limited",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
    {
      name: "Wooden Street",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
    {
      name: "Furlenco",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
    {
      name: "HomeLane",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
    {
      name: "Livspace",
      threat_level: "medium",
      market_share: 0,
      sentiment: 0,
    },
  ],
  share_of_voice: [
    {
      channel: "Digital/Social Media",
      distribution: {
        Wakefit: 23,
        Duroflex: 17,
        "The Sleep Company": 28,
        Pepperfry: 14,
        Others: 18,
      },
    },
    {
      channel: "E-commerce Platforms",
      distribution: {
        Wakefit: 33,
        Duroflex: 14,
        "The Sleep Company": 11,
        Pepperfry: 18,
        Others: 24,
      },
    },
    {
      channel: "Offline Retail/Stores",
      distribution: {
        Wakefit: 13,
        Duroflex: 23,
        "The Sleep Company": 9,
        Pepperfry: 38,
        Others: 17,
      },
    },
    {
      channel: "Search/SEO",
      distribution: {
        Wakefit: 28,
        Duroflex: 14,
        "The Sleep Company": 9,
        Pepperfry: 23,
        Others: 26,
      },
    },
  ],
  competitive_benchmarking: [
    {
      metric_name: "Brand Awareness Score",
      brands: [
        {
          brand_name: "Sheela Foam (Sleepwell)",
          score: 95,
        },
        {
          brand_name: "Kurlon",
          score: 90,
        },
        {
          brand_name: "Duroflex",
          score: 85,
        },
        {
          brand_name: "Wakefit",
          score: 75,
        },
        {
          brand_name: "The Sleep Company",
          score: 65,
        },
        {
          brand_name: "Pepperfry",
          score: 70,
        },
        {
          brand_name: "SleepyCat",
          score: 55,
        },
      ],
    },
    {
      metric_name: "Customer Satisfaction Score",
      brands: [
        {
          brand_name: "Flo Mattress",
          score: 84,
        },
        {
          brand_name: "SleepyCat",
          score: 74,
        },
        {
          brand_name: "Sunday Mattress",
          score: 80,
        },
        {
          brand_name: "Duroflex",
          score: 68,
        },
        {
          brand_name: "Sleepyhead",
          score: 63,
        },
        {
          brand_name: "Wakefit",
          score: 30,
        },
        {
          brand_name: "Pepperfry",
          score: 35,
        },
      ],
    },
    {
      metric_name: "Net Promoter Score (Estimated)",
      brands: [
        {
          brand_name: "Sunday Mattress",
          score: 75,
        },
        {
          brand_name: "The Sleep Company",
          score: 70,
        },
        {
          brand_name: "Flo Mattress",
          score: 68,
        },
        {
          brand_name: "SleepyCat",
          score: 65,
        },
        {
          brand_name: "Duroflex",
          score: 60,
        },
        {
          brand_name: "Wakefit",
          score: 35,
        },
        {
          brand_name: "Pepperfry",
          score: 40,
        },
      ],
    },
    {
      metric_name: "Product Quality & Reliability Score",
      brands: [
        {
          brand_name: "Sunday Mattress",
          score: 92,
        },
        {
          brand_name: "Duroflex",
          score: 88,
        },
        {
          brand_name: "The Sleep Company",
          score: 85,
        },
        {
          brand_name: "Wakefit",
          score: 78,
        },
        {
          brand_name: "SleepyCat",
          score: 75,
        },
        {
          brand_name: "Flo Mattress",
          score: 73,
        },
        {
          brand_name: "Sleepyhead",
          score: 68,
        },
      ],
    },
    {
      metric_name: "Digital Engagement Score",
      brands: [
        {
          brand_name: "Pepperfry",
          score: 85,
        },
        {
          brand_name: "Wakefit",
          score: 75,
        },
        {
          brand_name: "The Sleep Company",
          score: 70,
        },
        {
          brand_name: "Duroflex",
          score: 65,
        },
        {
          brand_name: "SleepyCat",
          score: 60,
        },
        {
          brand_name: "Urban Ladder",
          score: 55,
        },
        {
          brand_name: "Wooden Street",
          score: 58,
        },
      ],
    },
    {
      metric_name: "Innovation & Technology Score",
      brands: [
        {
          brand_name: "The Sleep Company",
          score: 95,
        },
        {
          brand_name: "Wakefit",
          score: 82,
        },
        {
          brand_name: "Sunday Mattress",
          score: 78,
        },
        {
          brand_name: "SleepyCat",
          score: 75,
        },
        {
          brand_name: "Duroflex",
          score: 72,
        },
        {
          brand_name: "Flo Mattress",
          score: 68,
        },
        {
          brand_name: "Sleepyhead",
          score: 60,
        },
      ],
    },
  ],
  positioning: {
    competitive_advantages: [
      "Largest D2C home furnishings company in India by revenue",
      "Complete vertical integration from R&D to distribution",
      "Strong omnichannel presence with 130+ stores",
      "Diverse product portfolio across mattresses, furniture, and furnishings",
      "Robust digital presence with high website traffic",
    ],
    improvement_areas: ["Critically low customer satisfaction scores", "Widespread customer service complaints", "Reputation risk due to negative reviews", "Logistics and replacement process issues"],
    disruption_watchlist: [
      "The Sleep Company's rapid growth and innovation",
      "Legacy players like Sheela Foam and Duroflex",
      "IKEA's expanding omnichannel presence",
      "Reliance-backed Urban Ladder's potential aggressive expansion",
    ],
  },
};

const audienceIntelligence: AudienceIntelligence = {
  audience_summary:
    "Wakefit's target audience primarily consists of urban millennials and Gen Z aged 18-35, with a strong focus on middle to upper-middle income households. They are digitally native, value-conscious, and prioritize health and wellness, seeking quality sleep products at affordable prices.",
  core_demographics: {
    primary_age_range: "25-34",
    gender_split: {
      male: 57.5,
      female: 42.5,
    },
    income_median_usd: 5497,
    location_type: "Urban",
    demographics_distribution: {
      age: [
        { age_range: "18-24", percentage: 10 },
        { age_range: "25-34", percentage: 30 },
        { age_range: "35-44", percentage: 20 },
        { age_range: "45-54", percentage: 10 },
        { age_range: "55+", percentage: 30 },
      ],
      education: [
        { education_level: "High School", percentage: 10 },
        { education_level: "Bachelor's Degree", percentage: 30 },
        { education_level: "Master's Degree", percentage: 20 },
        { education_level: "PhD", percentage: 10 },
        { education_level: "Other", percentage: 30 },
      ],
      geographic: [
        { location: "Urban", percentage: 30 },
        { location: "Suburban", percentage: 40 },
        { location: "Rural", percentage: 30 },
      ],
    },
  },
  occupation_distribution: [
    { occupation: "Software Engineer", percentage: 10 },
    { occupation: "Teacher", percentage: 30 },
    { occupation: "Doctor", percentage: 20 },
    { occupation: "Lawyer", percentage: 10 },
    { occupation: "Other", percentage: 30 },
  ],
  interests: {
    top_categories: [
      {
        category: "Sleep Health & Wellness",
        score: 9,
      },
      {
        category: "Home Improvement & Interior Design",
        score: 8,
      },
      {
        category: "Technology & Gadgets",
        score: 8,
      },
      {
        category: "Fitness & Lifestyle",
        score: 7,
      },
      {
        category: "E-commerce & Online Shopping",
        score: 8,
      },
      {
        category: "Social Media & Content Consumption",
        score: 8,
      },
      {
        category: "Career & Professional Development",
        score: 7,
      },
      {
        category: "Real Estate & Property",
        score: 7,
      },
      {
        category: "Sustainable Living",
        score: 6,
      },
      {
        category: "Entertainment & Streaming",
        score: 7,
      },
    ],
    brand_affinities: [
      {
        brand: "Amazon",
        affinity: 75,
      },
      {
        brand: "Flipkart",
        affinity: 70,
      },
      {
        brand: "IKEA",
        affinity: 55,
      },
      {
        brand: "Urban Ladder",
        affinity: 50,
      },
      {
        brand: "Pepperfry",
        affinity: 48,
      },
      {
        brand: "Sleepwell",
        affinity: 45,
      },
      {
        brand: "Godrej Interio",
        affinity: 42,
      },
      {
        brand: "Duroflex",
        affinity: 40,
      },
      {
        brand: "The Sleep Company",
        affinity: 38,
      },
      {
        brand: "Rentomojo",
        affinity: 35,
      },
    ],
  },
  behavioral_insights: {
    shopping_behavior: {
      purchase_channel_distribution: {
        "Own Website/App": 38.7,
        "Company-Owned Retail Stores": 23.2,
        Amazon: 20.6,
        Flipkart: 13.9,
        "Quick Commerce/Other Marketplaces": 3.6,
      },
      purchase_frequency: "0.8-1.2x per year",
      avg_order_value_usd: 165,
    },
    decision_journey: {
      stages: [
        {
          stage: 1,
          name: "Sleep Problem Identification",
          description: "Recognize sleep issues, back pain, or need for home upgrade; exposed to brand through social media, ads, or word-of-mouth",
          duration_days: 10,
        },
        {
          stage: 2,
          name: "Active Research & Comparison",
          description: "Digital-native shoppers leverage e-commerce to compare features, pricing, reviews; watch YouTube reviews, read blogs, check multiple brands",
          duration_days: 17,
        },
        {
          stage: 3,
          name: "Product Evaluation",
          description: "100-day trial policy addresses experiential angle; may visit experience centers, seek detailed specifications, consult customer support",
          duration_days: 8,
        },
        {
          stage: 4,
          name: "Transaction & Order",
          description: "Complete purchase online or at retail store; select size, type, delivery options; payment via digital or cash",
          duration_days: 1,
        },
        {
          stage: 5,
          name: "Experience & Sharing",
          description: "Wakefit makes 4500 outbound customer calls daily for feedback; customers share reviews, refer friends, consider complementary purchases",
          duration_days: 65,
        },
      ],
    },
    media_and_device_usage: {
      device_preference: {
        "Mobile/Smartphone": 67.5,
        "Desktop/Laptop": 23.5,
        Tablet: 9,
      },
      media_channels: {
        YouTube: 27.5,
        Instagram: 23.7,
        WhatsApp: 18,
        Facebook: 12.3,
        "Google Search/SEO": 10.4,
        "Email Marketing": 4.3,
        "Twitter/X": 2.4,
        "Other (LinkedIn, Pinterest)": 1.4,
      },
    },
  },
  platforms: {
    distribution: {
      "Own Website/App": 38.7,
      "Company-Owned Retail Stores": 23.2,
      Amazon: 20.6,
      Flipkart: 13.9,
      "Quick Commerce/Other Marketplaces": 3.6,
    },
  },
};

const socialAndDigital: SocialAndDigital = {
  platform_metrics: [
    {
      platform: "Instagram",
      followers: 177000,
      health_score: 85,
    },
    {
      platform: "LinkedIn",
      followers: 58212,
      health_score: 90,
    },
    {
      platform: "YouTube",
      followers: 50000,
      health_score: 75,
    },
    {
      platform: "Facebook",
      followers: 100000,
      health_score: 85,
    },
    {
      platform: "Twitter (X)",
      followers: 25000,
      health_score: 70,
    },
    {
      platform: "TikTok",
      followers: 0,
      health_score: 0,
    },
    {
      platform: "Pinterest",
      followers: 0,
      health_score: 0,
    },
    {
      platform: "E-commerce Marketplaces",
      followers: 0,
      health_score: 85,
    },
  ],
  sentiment_distribution: [
    {
      label: "Positive",
      percentage: 60,
    },
    {
      label: "Neutral",
      percentage: 30,
    },
    {
      label: "Negative",
      percentage: 10,
    },
  ],
  recent_comments: [
    {
      user: "john_doe",
      platform: "Instagram",
      timeAgo: "2 days ago",
      status: "positive",
      commentText: "Love the new mattress! Super comfy.",
      postContext: "Product launch post",
    },
    {
      user: "alex_92",
      platform: "LinkedIn",
      timeAgo: "3 days ago",
      status: "positive",
      commentText: "Great insights on the latest home trends!",
      postContext: "Industry insights post",
    },
  ],
  engagement: {
    engagement_by_platform: [
      {
        platform: "Instagram",
        engagement_rate: 2,
      },
      {
        platform: "LinkedIn",
        engagement_rate: 7,
      },
      {
        platform: "YouTube",
        engagement_rate: 2.5,
      },
      {
        platform: "Facebook",
        engagement_rate: 30,
      },
      {
        platform: "Twitter (X)",
        engagement_rate: 20,
      },
    ],
    best_performing_content_types: [
      {
        content_type: "Long-Form Video Content (YouTube)",
        performance: 9,
      },
      {
        content_type: "Instagram Reels",
        performance: 8,
      },
      {
        content_type: "LinkedIn Thought Leadership & Employee Stories",
        performance: 8,
      },
      {
        content_type: "Campaign-Driven Content (Multi-Platform)",
        performance: 10,
      },
      {
        content_type: "User-Generated Content (UGC)",
        performance: 7,
      },
      {
        content_type: "Stories (Instagram/Facebook)",
        performance: 6,
      },
      {
        content_type: "Carousel Posts (Instagram)",
        performance: 5,
      },
    ],
    follower_growth_trend: [
      {
        month: "October 2019",
        followers: 2375,
      },
      {
        month: "November 2019",
        followers: 4750,
      },
      {
        month: "June 2021",
        followers: 30000,
      },
      {
        month: "February 2025",
        followers: 50000,
      },
    ],
  },
};

export const mBrandIntelligenceWakefit = {
  brand,
  creative_system: creativeSystem,
  market_intelligence: marketIntelligence,
  competitive_intel: competitiveIntel,
  audience_intelligence: audienceIntelligence,
  social_and_digital: socialAndDigital,
};
